module.exports = __webpack_public_path__ + "img/banner7.d2132fe2.png";